/*
 * @描叙: 支付相关功能接口
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-08-10 10:22:32 
*/

import { $post, $get,$patch} from '@/utils/http'
import Service from './Service'

// 获取项目的表头设置
Service.getBillset = async function () {
    let request = {}
    // 项目Id
    request['project_sys_id'] = Service.getProjectSystemId();
    if (!request['project_sys_id']) return;

    let data = await $get('/ucenter/v2/projects/billsetting', request, true);
    return Service.handleCommonError(data)
}

// 删除表头设置
Service.delBillset = async function (params) {
    
    let data = await $post('/ucenter/v2/projects/billsetting/del', params);
    return Service.handleCommonError(data)
}

// 添加
Service.addBillset = async function (params) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/projects/billsetting/add', params);
    return Service.handleCommonError(data)
}

// 修改
Service.editBillset = async function (params) {
	params['project_sys_id'] = Service.getProjectSystemId();
	if (!params['project_sys_id']) return;
    let data = await $patch('/ucenter/v2/projects/billsetting', params);
    return Service.handleCommonError(data)
}

// 根据id获取表头
Service.getBillsetOid = async function (params) {
   
    let data = await $get('/ucenter/v2/projects/billsetting/byoid', params, true);
    return Service.handleCommonError(data)
}